module.exports = __webpack_public_path__ + "img/BRCA2_Fibroblasts.14e04ac7.png";